import { initializeProductCategory } from "./product-category.js";
import { initializeSupplierStore } from "./supplier-store.js";
import { initializeUnitConversion } from "./units-conversion.js";
import { initializeRecentlyAddedProducts } from "./recently-added-products.js";
import { initializeSupplierDirectory } from "./supplier-directory.js";
import { initializeSearch } from "./search.js";
import { initializeSearchCategoryResults } from "./search-category-results.js";
import { initializeVolumePricing } from "./volume-pricing.js";

const init = () => {
  const recentlyAddedProductsElement = document.getElementById(
    "chamfr-recently-added-products"
  );
  const productCategoryElement = document.getElementById(
    "chamfr-product-category"
  );
  const supplierStoreElement = document.getElementById("chamfr-supplier-store");
  const supplierDirectoryElement = document.getElementById(
    "chamfr-supplier-directory"
  );
  const chamfrNewSearchElement = document.getElementById(
    "chamfr-search-results-new"
  );
  const chamfrSearchCategoryResultsElement = document.getElementById(
    "chamfr-search-category-results"
  );

  if (productCategoryElement) {
    initializeProductCategory(productCategoryElement);
  } else if (supplierStoreElement) {
    initializeSupplierStore(supplierStoreElement);
  } else if (recentlyAddedProductsElement) {
    initializeRecentlyAddedProducts(recentlyAddedProductsElement);
  } else if (supplierDirectoryElement) {
    initializeSupplierDirectory();
  } else if (chamfrNewSearchElement) {
    initializeSearch(chamfrNewSearchElement);
  } else if (chamfrSearchCategoryResultsElement) {
    initializeSearchCategoryResults(chamfrSearchCategoryResultsElement);
  }

  initializeUnitConversion();
  initializeVolumePricing();
};

document.addEventListener("DOMContentLoaded", init);
